import {
  useFlashMessages,
  useWithAppState,
} from "@towersystems/roam-common-native";
import { useActiveTerminal } from "../../utilities/app-state/hooks";
import React from "react";

export const ValidActiveTerminalGuard = () => {
  const { terminal } = useActiveTerminal();
  const flashMessagesContext = useFlashMessages();
  const { updateAppState } = useWithAppState();

  React.useEffect(() => {
    if (terminal && terminal.enabled === false) {
      flashMessagesContext.showMessage({
        severity: "error",
        message:
          "The active terminal is no longer valid. Please select a different terminal.",
      });
      updateAppState({ terminalId: null });
    }
  }, [terminal?.enabled]);
  return null;
};
